<template>
  <pdf-gen
    :header-data="Array(pdf_header)"
    :page-margins="[15, 110, 15, 60]"
    :footer-data="Array(pdf_footer)"
    :content-data="Array(pdf_content)"
    ref="invoice"
    :name="data['bill_number'] + ' ' + data.project.name + ' Vk ' + weeks"
  />
</template>

<script>
import PdfGen from "components/pdf/pdfGen";
import {mapGetters} from "vuex";

export default {
  name: "FinanceInvoiceShowPdf",
  components: {PdfGen},
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    ...mapGetters(['companiesConfig']),
    ...mapGetters('commonPaymentTerms', {listPaymentTerm: 'getCommonPaymentTermGrid'}),
    t() {
      return this.localStorage.translations.pages.finance['invoice-table']
    },
    p() {
      return this.localStorage.translations.pages.finance['period-table']
    },
    bill() {
      if (this.data['bill_created_at']) {
        let result = new Date(this.data['bill_created_at'])
        return String(result.getDate()).padStart(2, '0') + '.' +
          String(result.getMonth() + 1).padStart(2, '0') + '.' +
          result.getFullYear()
      }
      return '-'
    },
    weeks() {
      if (this.data['first_week'] === this.data['last_week']) return this.data['first_week'] || '-'
      return this.data['first_week'] + '-' + this.data['last_week']
    },
    showData() {
      return this.data['extra_works'].every((current) => {
        return current['tax_percent'] === this.data['tax_percent']
      })
    },
    LastDay() {
      let temp = this.data['bill_last_day_to_pay'] ? this.data['bill_last_day_to_pay'].split('-') : []
      if (temp.length) return temp[2] + '.' + temp[1] + '.' + temp[0]
      return '-'
    },
    DayToPay() {
      let temp = this.data['bill_days_to_pay'] !== null
        ? this.listPaymentTerm.filter(i => i.days == this.data['bill_days_to_pay'])
        : []
      if (temp[0]) return temp[0].days ? temp[0].description + ' ' + this.t['day_term'] : temp[0].description
      return this.data['bill_days_to_pay'] !== null ? this.data['bill_days_to_pay'] + ' ' + this.t['day_term'] : ''
    },
    pdf_header() {
      return {
        style: 'h9',
        columns: [
          {
            table: {
              widths: ['*', 162, 110],
              body: [
                [
                  [
                    {
                      image: 'logo',
                      width: 50,
                      height: 50,
                      margin: [15, 10, 10, 10],
                    },
                    {
                      text: this.companiesConfig.company_name,
                      margin: [15, 0, 10, 0],
                    },
                    {
                      text:
                        this.companiesConfig.registration_address_street +
                        ', ' +
                        this.companiesConfig.registration_address_zip +
                        ', ' +
                        this.companiesConfig.registration_address_city,
                      margin: [15, 0, 10, 5],
                    },
                  ],
                  [
                    {
                      text: this.t['invoice_created'],
                      style: 'h9bold',
                      margin: [0, 30, 0, 3],
                    },
                    {text: this.bill},
                  ],
                  [
                    {
                      text: this.t['invoice_number'],
                      style: 'h9bold',
                      margin: [0, 30, 0, 0],
                    },
                    {text: this.data['bill_number'] || '-',},
                  ],
                ],
              ],
            },
            layout: {
              hLineColor: '#d2d5d9',
              hLineWidth: function (i) {
                return i === 0 ? 0 : 0.25
              },
              vLineWidth: function (i) {
                return 0
              },
            },
          },
        ],
      }
    },
    pdf_footer() {
      return {
        style: 'h9',
        columns: [
          {
            table: {
              widths: [130, '*', 100, 130],
              body: [
                [
                  {
                    border: [false, true, false, false],
                    columns: [
                      [
                        {
                          text: this.companiesConfig.company_name,
                          style: 'h9bold',
                          margin: [15, 5, 0, 0],
                        },
                        {
                          text: this.companiesConfig.registration_address_street,
                          margin: [15, 0, 0, 0],
                        },
                        {
                          text: this.companiesConfig.registration_address_zip + ', ' + this.companiesConfig.registration_address_city,
                          margin: [15, 0, 0, 10],
                        },
                      ]
                    ],
                  },
                  {
                    border: [false, true, false, false],
                    columns: [
                      [
                        {
                          text: this.t['y-tunnus'] + ': ' + String(this.companiesConfig.company_id || ''),
                          margin: [0, 5, 0, 0],
                        },
                        {text: this.t['alv'] + ': ' + String(this.companiesConfig.vat || '')},
                        {text: this.t['phone'] + ': ' + String(this.companiesConfig.phone || '')},
                        {
                          text: this.t['email'] + ': ' + String(this.companiesConfig.laskut_email || ''),
                          margin: [0, 0, 0, 10],
                        },
                      ],
                    ]
                  },
                  {
                    border: [false, true, false, false],
                    columns: [
                      [
                        {text: 'BIC', style: 'h9bold', margin: [0, 5, 0, 0]},
                        {text: this.companiesConfig.bic || ''},
                      ],
                    ]
                  },
                  {
                    border: [false, true, false, false],
                    columns: [
                      [
                        {text: 'IBAN', style: 'h9bold', margin: [0, 5, 15, 0]},
                        {text: this.companiesConfig.iban || '', margin: [0, 0, 15, 0]},
                      ],
                    ]
                  },
                ],
              ],
            },
            layout: {
              hLineColor: '#d2d5d9',
              hLineWidth: function (i) {
                return 0.25
              },
            },
          },
        ],
      }
    },
    pdf_content() {
      let temp = [
        {
          style: 'h9',
          columns: [
            {
              width: '*',
              columns: [
                [
                  {text: this.t['billing_address'], style: 'h9bold'},
                  {
                    text: this.data.client.name +
                      String(this.data.invoicing_company ? ' - ' + this.data.invoicing_company.name : '')
                  },
                  {
                    text: this.data.client.registration_street || ''
                  },
                  {
                    text:
                      (this.data.client.registration_zip || '') +
                      ' ' +
                      (this.data.client.registration_city || '').toUpperCase(),
                  },
                ],
              ],
            },
            {
              width: 170,
              columns: [
                [
                  {text: this.t['client_number'], style: 'h9bold'},
                  {text: this.t['term'], style: 'h9bold'},
                  {text: this.t['pay_link'], style: 'h9bold'},
                  {text: this.t['pay_terms'], style: 'h9bold'},
                  {text: this.t['pay_interest'], style: 'h9bold'},
                  {text: this.t['vendor_phone'], style: 'h9bold'},
                  {text: this.t['supplier_email'], style: 'h9bold'},
                  {text: this.t['alv'], style: 'h9bold'},
                ],
              ],
            },
            {
              width: 100,
              columns: [
                [
                  {text: this.data.client.id || '-'},
                  {text: this.LastDay},
                  {
                    text: this.data['bill_link'] || '-',
                  },
                  {text: this.DayToPay},
                  {text: '8.5%'},
                  {text: this.companiesConfig.phone || ''},
                  {text: this.companiesConfig.laskut_email || ''},
                  {text: this.companiesConfig.vat || ''},
                ],
              ],
            },
          ],
        },
        {
          style: 'h9',
          margin: [0, 10, 0, 10],
          table: {
            widths: ['*', '*'],
            body: [
              [
                {
                  table: {
                    widths: [70, '*'],
                    body: [
                      [
                        {text: this.p['project'], style: 'mt'},
                        {text: this.data.project.name || '', style: 'mt'},
                      ],
                      [
                        {text: this.p['address'], style: 'mt'},
                        {
                          text:
                            this.data.project.street +
                            ', ' +
                            this.data.project.zip +
                            ', ' +
                            this.data.project.city,
                          style: 'mt',
                        },
                      ],
                      [
                        {text: this.p['term'], style: 'mt'},
                        {
                          text:
                            this.$formatDate(this.data.period_report.start_date) + ' - ' +
                            this.$formatDate(this.data.period_report.end_date) +
                            ' Vk ' + this.weeks,
                          style: 'mt',
                        },
                      ],
                    ],
                  },
                  border: [false, false, true, false],
                  layout: {
                    hLineColor: '#d2d5d9',
                    vLineWidth: function () {
                      return 0
                    },
                    hLineWidth: function (i) {
                      return i !== 0 ? 0.25 : 0
                    },
                    paddingTop: function () {
                      return 0
                    },
                    paddingBottom: function () {
                      return 0
                    },
                  },
                },
                {
                  table: {
                    widths: [70, '*'],
                    body: [
                      [
                        {text: this.p['client'], style: 'mt'},
                        {text: this.data.client.name || '', style: 'mt'},
                      ],
                      [
                        {text: this.p['subscriber'], style: 'mt'},
                        {
                          text:
                            String(this?.data?.project?.manager?.first_name || '-') +
                            ' ' +
                            String(this?.data?.project?.manager?.last_name || ''),
                          style: 'mt',
                        },
                      ],
                      [
                        {text: this.p['tel'], style: 'mt'},
                        {
                          text: this?.data?.project?.manager?.phone || '-',
                          style: 'mt',
                        },
                      ],
                    ],
                  },
                  border: [true, false, false, false],
                  layout: {
                    hLineColor: '#d2d5d9',
                    vLineWidth: function () {
                      return 0
                    },
                    hLineWidth: function (i) {
                      return i !== 0 ? 0.25 : 0
                    },
                    paddingTop: function () {
                      return 0
                    },
                    paddingBottom: function () {
                      return 0
                    },
                  },
                },
              ],
            ],
          },
          layout: {
            vLineColor: '#d2d5d9',
            vLineWidth: function () {
              return 0.25
            },
            paddingLeft: function (i) {
              return i === 0 ? 0 : 4
            },
            paddingRight: function (i) {
              return i === 0 ? 4 : 0
            },
          },
        },
        {
          style: 'h9',
          table: {
            headerRows: 1,
            widths: ['auto', 'auto', '*', 'auto', 'auto', 'auto', 'auto'],
            body: [
              [
                {text: this.p['position'], alignment: 'center', style: 'h8'},
                {text: this.p['quantity'], alignment: 'center', style: 'h8'},
                {text: this.p['work'], alignment: 'center', style: 'h8'},
                {text: this.t['price_discount'], alignment: 'center', style: 'h8'},
                {text: this.t['alv_table'], alignment: 'center', style: 'h8'},
                {text: this.t['taxfree_sum'], alignment: 'center', style: 'h8'},
                {text: this.t['taxable_sum'], alignment: 'center', style: 'h8'},
              ],
            ],
          },
          layout: {
            vLineColor: '#ebebeb',
            hLineColor: '#ebebeb',
            paddingTop: function (i, node) {
              return 6
            },
            paddingBottom: function (i, node) {
              return 2
            },
            fillColor: function (rowIndex, node, columnIndex) {
              return rowIndex === 0 ? '#f2f2f2' : null
            },
          },
        },
        {
          style: 'h9',
          margin: [0, 10, 0, 10],
          columns: [
            {width: '*', text: ''},
            {
              width: 170,
              columns: [
                [
                  {text: this.t['total_taxfree_sum'], style: 'h9bold'},
                  {text: this.t['total_taxable_sum'], style: 'h9bold'},
                  {text: this.t['total_invoice_sum'], style: 'h9bold'},
                ],
              ],
            },
            {
              width: 100,
              columns: [
                [
                  {
                    text: this.$formatCurrency(this.data['price']) + ' EUR',
                    alignment: 'right',
                  },
                  {
                    text: this.$formatCurrency(this.data['tax']) + ' EUR',
                    alignment: 'right',
                  },
                  {
                    text: this.$formatCurrency(this.data['total_price']) + ' EUR',
                    alignment: 'right',
                  },
                ],
              ],
            },
          ],
        },
      ]
      let arr = ['work_types', 'extra_works']
      for (let a in arr) {
        let field = arr[a]
        let work = this.data[field].filter(i => i.id !== null && i.name !== null)
        if (field === 'extra_works' && work.length) {
          temp[2].table.body.push([
            {text: this.data['work_types'].filter(i => i.id !== null && i.name !== null).length + 1, style: 'h9bold'},
            {
              text: this.$formatTime(
                Object.values(work).reduce((sum, current) => {
                  return sum + current['approved_report']
                }, 0),
              ),
              style: 'h9bold'
            },
            {
              text: this.localStorage.translations.pages.finance['period-table']['total-extra'],
              style: 'h9bold'
            },
            {
              text: this.showData ? this.$formatCurrency(work[0].price) : '',
              style: 'h9bold',
              alignment: 'center'
            },
            {
              text: this.showData ? this.data['tax_percent'] + '%' : '',
              style: 'h9bold',
              alignment: 'center'
            },
            {
              text: this.showData ? this.$formatCurrency(this.data['extra_works'].reduce((sum, current) => {
                return sum + current['total_price']
              }, 0)) : '',
              style: 'h9bold',
              alignment: 'center'
            },
            {
              text: this.showData ? this.$formatCurrency(this.data['extra_works'].reduce((sum, current) => {
                return sum + current['total_price_with_tax']
              }, 0)) : '',
              style: 'h9bold',
              alignment: 'center'
            },
          ])
        }
        for (let i in work) {
          temp[2].table.body.push([
            {
              text: field === 'extra_works'
                ? this.data['work_types'].length + 1 + '.' + Number(Number(i) + 1)
                : Number(i) + 1,
              style: field === 'extra_works' ? '' : 'h9bold'
            },
            {
              text: [
                {
                  text: work[i].is_hourly === 0
                    ? work[i]['approved_report']
                    : this.$formatTime(work[i]['approved_report']),
                  style: field === 'extra_works' ? '' : 'h9bold',
                },
                {
                  text: work[i].is_hourly === 0 ? ' ' + work[i].measure : '',
                  style: field === 'extra_works' ? '' : 'roboto-black',
                },
              ]
            },
            {text: work[i].name, style: field === 'extra_works' ? '' : 'h9bold'},
            {
              text: this.$formatCurrency(work[i].price),
              style: field === 'extra_works' ? '' : 'h9bold',
              alignment: 'center'
            },
            {text: work[i]['tax_percent'] + '%', style: field === 'extra_works' ? '' : 'h9bold', alignment: 'center'},
            {
              text: this.$formatCurrency(work[i]['total_price']),
              style: field === 'extra_works' ? '' : 'h9bold',
              alignment: 'center'
            },
            {
              text: this.$formatCurrency(work[i]['total_price_with_tax']),
              style: field === 'extra_works' ? '' : 'h9bold',
              alignment: 'center'
            },
          ])
        }
      }
      return temp
    }
  },
}
</script>
